export async function validatePfxFile(file: File) {
  const buffer = await file.arrayBuffer();
  const uint8Array = new Uint8Array(buffer.slice(0, 9));

  return (
    uint8Array[0] === 48 &&
    uint8Array[1] === 130 &&
    uint8Array[0] === uint8Array[7] &&
    uint8Array[1] === uint8Array[8]
  );
}
